import { Grid } from '@mui/material';
import { ODSTagStatic, ODSText } from '@telekom-ods/react-ui-kit';
import type { ODSTagStaticType } from '@telekom-ods/react-ui-kit';
import type { ReactNode } from 'react';

import './UpgradeCluster.css';

interface InfoRowProps {
  label: string;
  value: string;
  tagType?: ODSTagStaticType | undefined;
  icon?: ReactNode;
}

const InfoRow = ({ label, value, tagType, icon }: InfoRowProps): React.JSX.Element => (
  <Grid
    container
    className='upgrade-row'
  >
    <ODSText
      as='p'
      className='upgrade-text'
    >
      {label}
    </ODSText>
    {tagType ? (
      <ODSTagStatic
        label={value}
        type={tagType}
        {...(icon ? { icon } : {})}
      />
    ) : (
      <ODSText
        as='p'
        className='upgrade-text'
      >
        {value}
      </ODSText>
    )}
  </Grid>
);

export default InfoRow;
